import React from 'react';
import PageBuilder from '../page_builder/PageBuilder.jsx';

export default function WebpageImporterEditor() {
    return <PageBuilder mode="importer" />;
}
